<div class="overflow-x-auto">
  <table class="table table-zebra" [class.!border-t-0]="!options()?.header?.show">
    <thead class="sticky top-0 z-10">
      <tr>
        @for (column of columns(); track column.field) {
          @let isOpenMenu =
            !column?.filter?.disabled &&
            showHeaderOption() &&
            column?.field !== 'rowNumber' &&
            column?.field !== 'checkbox';

          <th
            gridColumn
            [(align)]="align"
            [(orderBy)]="orderBy"
            [(selecteds)]="selecteds"
            [column]="column"
            [showHeaderOption]="showHeaderOption()"
            [class.open-menu]="isOpenMenu"
            class="border-0"
            [ngClass]="{
              'left-0 sticky z-10': column.type === 'checkbox',
            }"></th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of rowData(); track row.uniqueId) {
        <tr
          animate.enter="fade-in"
          gridRow
          class="hover"
          [class.cursor-pointer]="options()?.row?.clickHandler"
          [columns]="columns()!"
          [row]="row"
          [(selecteds)]="selecteds"></tr>
      } @empty {
        <tr>
          <td [attr.colspan]="columns().length" class="text-center">
            <p class="py-20 font-medium text-base-content/60">검색 결과를 찾을 수 없습니다.</p>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
